<style lang="less" scoped>
@import "/styles/SiteColors.less";
.search-group {
    .clear {
        position: absolute;
        right: 10px;
        z-index: 3;
        color: black;
        border: none;
        box-shadow: none;

        &:focus {
            outline-offset: 0;
            outline-color: @active-black;
        }
    }
}

.accessible-search-input {
    /**
    * Remove default clear icon of search input type.
    * https://stackoverflow.com/a/77190241
    */
    appearance: textfield;
    outline-offset: -2px; // Fix outline style in Safari

    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }
}

.search-group .clear {
    top: 50%;
    translate: 0 -50%;
    line-height: 1;
}
</style>

<template>
    <div class="search-group" role="search" :class="$attrs.class">
        <label v-if="labelOutsideInputGroup" :class="labelClass" :for="id">{{ label }}</label>
        <div class="input-group">
            <label v-if="!labelOutsideInputGroup" :class="labelClass" :for="id">{{ label }}</label>
            <input :id="id" type="text" ref="inputRef" v-model="searchTerm" :placeholder="placeholder" :autocomplete="autocomplete" :autofocus="autofocus" class="accessible-search-input rounded z-0" :class="inputClass" @submit.prevent />
            <button v-show="(searchTerm || '').length > 0" type="button" class="clear btn btn-bare icon icon-close rounded p-1" aria-label="Clear search" @click.stop="clearInput" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, toRefs, useAttrs } from "vue";

export default defineComponent({
    inheritAttrs: false,
    emits: ["update:modelValue", "clear"],
    props: {
        modelValue: {
            type: [String, null],
            default: "",
        },
        placeholder: {
            type: String,
            default: "Filter...",
        },
        label: {
            type: String,
            default: "Search input",
        },
        labelClass: {
            type: String,
            default: "sr-only",
        },
        labelOutsideInputGroup: {
            type: Boolean,
            default: false,
        },
        inputClass: {
            type: String,
            default: "",
        },
        autocomplete: {
            type: String,
            default: undefined,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const { modelValue } = toRefs(props);
        const inputRef = ref<HTMLInputElement>(null!);
        const attrs = useAttrs();

        const id = computed(() => attrs.id as string);
        const searchTerm = computed({
            get() {
                return modelValue.value;
            },
            set(newValue) {
                emit("update:modelValue", newValue);
            },
        });

        const clearInput = () => {
            searchTerm.value = "";
            emit("clear");

            if (inputRef.value) {
                inputRef.value.focus();
            }
        };

        return {
            id,
            searchTerm,
            clearInput,
            inputRef,
        };
    },
});
</script>
